import { encryptStorage } from 'src/Util'
import { documentsAPI, fixFileApi, tasksAPI } from '../api'

//Action Types
export const TOGGLE_THUMBNAIL = 'TOGGLE_THUMBNAIL'
export const TOGGLE_TAG_TRAY = 'TOGGLE_TAG_TRAY'
export const SHOW_OBJECT_PROPERTY = 'SHOW_OBJECT_PROPERTY'
export const SHOW_KEYBOARD_SHORTCUT = 'SHOW_KEYBOARD_SHORTCUT'
export const TOGGLE_FAV_TAG = 'TOGGLE_FAV_TAG'
export const TOGGLE_REPORT = 'TOGGLE_REPORT'
export const TOGGLE_BOOKMARKS = 'TOGGLE_BOOKMARKS'
export const TOGGLE_DOC_TAG_TRAY = 'TOGGLE_DOC_TAG_TRAY'

export const TOGGLE_TAGGING_MODE = 'TOGGLE_TAGGING_MODE'
export const TOGGLE_DOCUMENT_METADATA = 'TOGGLE_DOCUMENT_METADATA'
export const TOGGLE_ALT_TEXT = 'TOGGLE_ALT_TEXT'

export const DOCUMENT_METADATA = 'DOCUMENT_METADATA'
export const ALT_TEXT = 'ALT_TEXT'

export const THUMBNAIL = 'THUMBNAIL'
export const PAGE_FULL_IMAGE = 'PAGE_FULL_IMAGE'

export const VALIDATION_REPORT_DATA = 'VALIDATION_REPORT_DATA'
export const VIEW_BOOKMARKS = 'VIEW_BOOKMARKS'
export const BOOKMARK_UPDATE = 'BOOKMARK_UPDATE'
export const PAGE_DETAILS = 'PAGE_DETAILS'
export const METADATA_DETAILS = 'METADATA_DETAILS'
export const UPDATE_JSON_BOOKMARK = 'UPDATE_JSON_BOOKMARK'

export const FIG_ALT_TEXT_DATA = 'FIG_ALT_TEXT_DATA'
export const FOR_ALT_TEXT_DATA = 'FOR_ALT_TEXT_DATA'
export const TAB_ALT_TEXT_DATA = 'TAB_ALT_TEXT_DATA'
export const THUMBNAIL_ALT_TEXT = 'THUMBNAIL_ALT_TEXT'
export const VIEWER_TAGS = 'VIEWER_TAGS'
export const UPDATE_ALT_TEXT = 'UPDATE_ALT_TEXT'
export const UPDATE_ALT_TEXT_STATE='UPDATE_ALT_TEXT_STATE'
export const AUTO_MATH_API = 'AUTO_MATH_API'
export const APPLY_MATH_TEXT = 'APPLY_MATH_TEXT'

export const SET_TAGGING_MODE = 'SET_TAGGING_MODE'
export const APPLY_ALT_FILTER = 'APPLY_ALT_FILTER'

export const SET_LIST_OPR_VISIBILITY = 'SET_LIST_OPR_VISIBILITY'
export const SET_ZONE_OPR_VISIBILITY = 'SET_ZONE_OPR_VISIBILITY'
export const SET_TOC_OPR_VISIBILITY = 'SET_TOC_OPR_VISIBILITY'

export const SAVE_NOW = 'SAVE_NOW'
export const SAVE_MANUAL = 'SAVE_MANUAL'

//toolbar
export const SHOW_TAGS = 'SHOW_TAGS'
export const SHOW_READING_ORDER = 'SHOW_READING_ORDER'
export const SHOW_ZONE = 'SHOW_ZONE'
export const PREV_PAGE = 'PREV_PAGE'
export const NEXT_PAGE = 'NEXT_PAGE'
export const GOTO_PAGE = 'GOTO_PAGE'
export const UPDATE_TEMP_PAGENO = 'UPDATE_TEMP_PAGENO'
export const SET_ZOOM_PERCENT = 'SET_ZOOM_PERCENT'
export const SET_UNDO_EVENT = 'SET_UNDO_EVENT'
export const SET_UNDO_STACK = 'SET_UNDO_STACK'
export const SET_REDO_EVENT = 'SET_REDO_EVENT'
// export const CAN_DRAG ="CAN_DRAG"
export const SET_CAN_DRAG = 'SET_CAN_DRAG'
export const SET_CAN_DRAW_TAG = 'SET_CAN_DRAW_TAG'
export const SET_CURRENT_TAG_VALUE = 'SET_CURRENT_TAG_VALUE'
export const SET_NEW_COORDINATES = 'SET_NEW_COORDINATES'
export const SET_NEW_ALTFIG = 'SET_NEW_ALTFIG'
export const SET_NEW_ALTFOR = 'SET_NEW_ALTFOR'
export const SET_NEW_ALTTAB = 'SET_NEW_ALTTAB'
export const SET_TABLE_OPR_VISIBILITY = 'SET_TABLE_OPR_VISIBILITY'
export const SET_DRAW_ROW = 'SET_DRAW_ROW'
export const SET_DRAW_COLUMN = 'SET_DRAW_COLUMN'
export const SET_DELETE_ROW = 'SET_DELETE_ROW'
export const SET_DELETE_COLUMN = 'SET_DELETE_COLUMN'
export const SET_TABLE_TAG_GENERATED = 'SET_TABLE_TAG_GENERATED'
export const SET_MERGE_CELLS = 'SET_MERGE_CELLS'

export const SET_ZONE_MERGED = 'SET_ZONE_MERGED'
export const SET_TOC_CREATE = 'SET_TOC_CREATE'

export const SET_ZONE_DELETE = 'SET_ZONE_DELETE'

export const CLEAR_ZONES = 'CLEAR_ZONES'
export const CLEAR_READING_ORDER = 'CLEAR_READING_ORDER'
export const AUTO_REORDER = 'AUTO_REORDER'
export const MANUAL_ORDER = 'MANUAL_ORDER'
export const APPLY_ORDER = 'APPLY_ORDER'
export const END_ORDER = 'END_ORDER'
export const ADD_READING_ORDER = 'ADD_READING_ORDER'
export const SET_LAST_READING_ORDER = 'SET_LAST_READING_ORDER'
export const SET_SELECTED_TAG = 'SET_SELECTED_TAG'
export const SET_SELECTED_READING_ORDER = 'SET_SELECTED_READING_ORDER'
export const SET_SELECTED_ROWSPAN = 'SET_SELECTED_ROWSPAN'
export const SET_SELECTED_COLSPAN = 'SET_SELECTED_COLSPAN'
export const SET_SELECTED_SCOPE = 'SET_SELECTED_SCOPE'
export const SET_SELECTED_LINKTYPE = 'SET_SELECTED_LINKTYPE'
export const SET_SELECTED_FORMFIELD_REQUIRED = 'SET_SELECTED_FORMFIELD_REQUIRED'
export const SET_SELECTED_FORMFIELD_GROUPNAME = 'SET_SELECTED_FORMFIELD_GROUPNAME'
export const SET_SELECTED_FORMFIELD_TOOLTIP = 'SET_SELECTED_FORMFIELD_TOOLTIP'
export const SET_SELECTED_FORMFIELD_VALUE = 'SET_SELECTED_FORMFIELD_VALUE'
export const SET_SELECTED_HREF = 'SET_SELECTED_HREF'
export const SET_SELECTED_LEFT_DISTANCE = 'SET_SELECTED_LEFT_DISTANCE'
export const SET_SELECTED_TOP_DISTANCE = 'SET_SELECTED_TOP_DISTANCE'
export const SET_SELECTED_WIDTH_DISTANCE = 'SET_SELECTED_WIDTH_DISTANCE'
export const SET_SELECTED_HEIGHT_DISTANCE = 'SET_SELECTED_HEIGHT_DISTANCE'
export const SET_SELECTED_ZONE_COORDINATES = 'SET_SELECTED_ZONE_COORDINATES'
export const FINISH_TAGGING="FINISH_TAGGING"
export const FINISH_TASK="FINISH_TASK"
export const COMPLETE_REVIEW="COMPLETE_REVIEW"
export const SET_REVIEW_COMPLETE = "SET_REVIEW_COMPLETE"
export const SET_MERGE_OPR_VISIBILITY = "SET_MERGE_OPR_VISIBILITY"


export const SET_CLEAR_CELLS = 'SET_CLEAR_CELLS'
export const SET_DELETE_CELLS = 'SET_DELETE_CELLS'
export const CREATE_IMG = 'CREATE_IMG'
export const DELETE_IMG = 'DELETE_IMG'
export const BULK_DELETE_IMG = 'BULK_DELETE_IMG'
export const SELECTED_ZONE="SELECTED_ZONE"
export const ALTIMG_CHANGE="ALTIMG_CHANGE"
export const RESET_ALT_IMG="RESET_ALT_IMG"
export const RESET_ALT_IMG_VAL="RESET_ALT_IMG_VAL"
export const ALT_ONETIME_LOAD="ALT_ONETIME_LOAD"
export const RESET_ALT_UPDATE="RESET_ALT_UPDATE"
export const SET_ENABLE_GENERATE_TABLE="SET_ENABLE_GENERATE_TABLE"
export const SET_ENABLE_MERGE_CELLS="SET_ENABLE_MERGE_CELLS"
export const SET_SELECTED_TAG_ID = "SET_SELECTED_TAG_ID"
export const ADD_IN_COMPLETE_TABLE = "ADD_IN_COMPLETE_TABLE"
export const REMOVE_IN_COMPLETE_TABLE = "REMOVE_IN_COMPLETE_TABLE"
export const IMAGE_LOADING_STATUS = "IMAGE_LOADING_STATUS"
export const FOCUS_THUMBNAILS = "FOCUS_THUMBNAILS"
export const RESET_OBJ_PROPERTY = "RESET_OBJ_PROPERTY"
export const SELECTED_ZONE_VALUE = "SELECTED_ZONE_VALUE"
export const SAVE_DOC_VALUE = "SAVE_DOC_VALUE"
export const SHOW_METADATA_ALERT = "SHOW_METADATA_ALERT"
export const SET_APPLY_FLAG = "SET_APPLY_FLAG"
export const SET_THUMBNAIL_FOCUS = "SET_THUMBNAIL_FOCUS"
export const SET_BOOKMARK_TI = "SET_BOOKMARK_TI"
export const SET_BK_TRAY_TI = "SET_BK_TRAY_TI"
export const SET_DOC_TAG_TI = "SET_DOC_TAG_TI"
export const SET_DOC_TAG_TRAY_TI = "SET_DOC_TAG_TRAY_TI"
export const SET_REPORT_TI = "SET_REPORT_TI"
export const SET_VR_TRAY_TI = "SET_VR_TRAY_TI"
export const SET_TOPBAR_TI = "SET_TOPBAR_TI"
export const SET_DOC_DETAILS_TI = "SET_DOC_DETAILS_TI"
export const SET_DOC_DETAILS_TRAY_TI = "SET_DOC_DETAILS_TRAY_TI"
export const SET_TAG_TI = "SET_TAG_TI"
export const SET_TAG_TRAY_TI = "SET_TAG_TRAY_TI"
export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA"

export const PROCESS_IMG_FLAG = "PROCESS_IMG_FLAG"
export const UPDATE_READ_ORDER = "UPDATE_READ_ORDER"
//Action Creators
export const setClearCells = (value) => (dispatch) => {
    dispatch({
      type: SET_CLEAR_CELLS,
      payload: value
    })
  }

  export const setDeleteCells = (value) => (dispatch) => {
    dispatch({
      type: SET_DELETE_CELLS,
      payload: value
    })
  }


export const clearZones = (value) => (dispatch) => {
  dispatch({
    type: CLEAR_ZONES,
    payload: value
  })
}

export const clearReadingOrder = () => (dispatch) => {
  dispatch({
    type: CLEAR_READING_ORDER,
  })
}

export const autoReOrder = () => (dispatch) => {
  dispatch({
    type: AUTO_REORDER,
  })
}

export const applyOrder = () => (dispatch) => {
  dispatch({
    type: APPLY_ORDER,
  })
}

export const endOrder = () => (dispatch) => {
  dispatch({
    type: END_ORDER,
  })
}
export const addReadingOrder = (coor_idx) => (dispatch) => {
  dispatch({
    type: ADD_READING_ORDER,
    payload: coor_idx,
  })
}

export const setselectedRorder = (ro) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_READING_ORDER,
      payload: ro,
    })
  }

  export const setselectedRSpan = (rowspan) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_ROWSPAN,
      payload: rowspan,
    })
  }
  
  export const setselectedTDScope = (scope) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_SCOPE,
      payload: scope,
    })
  }
  export const setselectedLT = (linktype) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_LINKTYPE,
      payload: linktype,
    })
  }
  export const setselectedHF = (href) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_HREF,
      payload: href,
    })
  }
  export const setselectedFDRq = (req) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_FORMFIELD_REQUIRED,
      payload: req,
    })
  }
  export const setselectedFDGName = (gname) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_FORMFIELD_GROUPNAME,
      payload: gname,
    })
  }
  export const setselectedFDTtip = (tooltip) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_FORMFIELD_TOOLTIP,
      payload: tooltip,
    })
  }
  export const setselectedFDVal = (val) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_FORMFIELD_VALUE,
      payload: val,
    })
  }

  export const setselectedCSpan = (colspan) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_COLSPAN,
      payload: colspan,
    })
  }

  export const setselectedLD = (val) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_LEFT_DISTANCE,
      payload: val,
    })
  }
  export const setselectedTD = (val) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_TOP_DISTANCE,
      payload: val,
    })
  }
  export const setselectedWD = (val) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_WIDTH_DISTANCE,
      payload: val,
    })
  }
  export const setselectedHD = (val) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_HEIGHT_DISTANCE,
      payload: val,
    })
  }

  export const setLastReadingOrder = (ro) => (dispatch) => {
    dispatch({
      type: SET_LAST_READING_ORDER,
      payload: ro,
    })
  }

  //setselectedTag
export const setselectedTag = (val) => (dispatch) => {
  console.log('setselectedTag action',val)
  dispatch({
    type: SET_SELECTED_TAG,
    payload: val,
  })
}
//setSelectedZoneCD
export const setSelectedZoneCD = (val) => (dispatch) => {
  console.log('setSelectedZoneCD',val)
  dispatch({
    type: SET_SELECTED_ZONE_COORDINATES,
    payload: val,
  })
}


export const manualOrder = () => (dispatch) => {
  dispatch({
    type: MANUAL_ORDER,
  })
}

export const applyMathText = (val) => (dispatch) => {
  dispatch({
    type: APPLY_MATH_TEXT,
    payload: val,
  })
}

export const applyAltFilter = (val) => (dispatch) => {
  dispatch({
    type: APPLY_ALT_FILTER,
    payload : val
  })
console.log("applyAltFilterxxx", val)
}

export const toggleThumbnail = () => (dispatch) => {
  dispatch({
    type: TOGGLE_THUMBNAIL,
  })
}

export const toggleObjectProperty = (val) => (dispatch) => {
  console.log('toggleObjectProperty action', val)
  dispatch({
    type: SHOW_OBJECT_PROPERTY,
    payload: val
  })
}

export const toggleKeyBoardShortcut = (val) => (dispatch) => {
  console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SHOW_KEYBOARD_SHORTCUT,
    payload: val
  })
}




export const toggleFavTags = () => (dispatch) => {
  console.log('Editor Actions')
  dispatch({
    type: TOGGLE_FAV_TAG,
  })
}
export const toggleReport = () => (dispatch) => {
  console.log('Editor Actions - Report')
  dispatch({
    type: TOGGLE_REPORT,
  })
}



export const toggleBookmark = () => (dispatch) => {
  console.log('Editor Actions - Bookmark')
  dispatch({
    type: TOGGLE_BOOKMARKS,
  })
}

export const toggleDocTagTray = () => (dispatch) => {
  console.log('Doc Tray')
  dispatch({
    type: TOGGLE_DOC_TAG_TRAY,
  })
}

export const toggleTaggingMode = () => (dispatch) => {
  console.log('Tagging Mode')
  dispatch({
    type: TOGGLE_TAGGING_MODE,
  })
}

export const toggleDocumentMetadata = () => (dispatch) => {
  console.log('Editor Actions - Document Metadata')
  dispatch({
    type: TOGGLE_DOCUMENT_METADATA,
  })
}
export const toggleAltText = () => (dispatch) => {
  console.log('Editor Actions - ALT Text')
  dispatch({
    type: TOGGLE_ALT_TEXT,
  })
}

export const setTaggingMode = (value) => (dispatch) => {
  dispatch({
    type: SET_TAGGING_MODE,
    payload: value,
  })
}

export const showTags = (value) => (dispatch) => {
  dispatch({
    type: SHOW_TAGS,
    payload: value,
  })
}

export const showReadingOrder = (value) => (dispatch) => {
  dispatch({
    type: SHOW_READING_ORDER,
    payload: value,
  })
}

export const showZone = (value) => (dispatch) => {
  dispatch({
    type: SHOW_ZONE,
    payload: value,
  })
}

export const nextPage = () => (dispatch) => {
  dispatch({
    type: NEXT_PAGE,
  })
}
export const prevPage = () => (dispatch) => {
  dispatch({
    type: PREV_PAGE,
  })
}
export const goToPage = (pageNo,overlapCheckRequired=true) => (dispatch) => {
  let data = {
    pageNo : pageNo,
    overlapCheckRequired : overlapCheckRequired
  }
  dispatch({
    type: GOTO_PAGE,
    payload: data,
  })
}
export const updateTempPageNo = (pageNo) => (dispatch) => {
  dispatch({
    type: UPDATE_TEMP_PAGENO,
    payload: pageNo,
  })
}

export const setZoom = (percentage) => (dispatch) => {
  console.log(percentage)
  dispatch({
    type: SET_ZOOM_PERCENT,
    payload: percentage,
  })
}

export const setUndoEvent = (UndoEvent) => (dispatch) => {
  dispatch({
    type: SET_UNDO_EVENT,
    payload: UndoEvent,
  })
}
//setRedoEvent
export const setRedoEvent = (RedoEvent) => (dispatch) => {
  dispatch({
    type: SET_REDO_EVENT,
    payload: RedoEvent,
  })
}

export const setUndoStackValue = (undoStackValue) => (dispatch) => {
  dispatch({
    type: SET_UNDO_STACK,
    payload: undoStackValue,
  })
}

export const setSaveNow = (savenow) => (dispatch) => {
  dispatch({
    type: SAVE_NOW,
    payload: savenow,
  })
}
export const setSaveManual = (savemanual) => (dispatch) => {
  dispatch({
    type: SAVE_MANUAL,
    payload: savemanual,
  })
}

export const setFinishTag = (finishTagging) => (dispatch) => {
  dispatch({
    type: FINISH_TAGGING,
    payload: finishTagging,
  })
}

export const setFinishTask = (finishTask) => (dispatch) => {
  //console.log("Print Finish",finishTask);
  dispatch({
    type: FINISH_TASK,
    payload: finishTask,
  })
}

export const updateReadOrder = (redord) => (dispatch) => {
  dispatch({
    type: UPDATE_READ_ORDER,
    payload: redord,
  })
}


// export const zoomOut =(percentage) =>(dispatch) =>{
//   dispatch({
//     type: GOTO_PAGE,
//     payload : percentage
//   })
// }

export const getValidationReport = (path) => (dispatch) => {
  console.log('Actions Validation Report API')
  tasksAPI
    .post(`/task/file/getjson/`, {
      company_id: 337,
      destinationPath: path,
    })
    .then((response) => {
      console.log('Actions Validation Report API -> Response', response)
      dispatch({
        type: VALIDATION_REPORT_DATA,
        payload: response.data.data,
      })
    })
}

export const downloadValidationReport = (path) => (dispatch) => {
  console.log('Actions Validation Report Download')

  tasksAPI
    .post(`/task/file/downloadForUser/`, {
      destinationPath: path,
      company_id: 337,
    })
    .then((response) => {
      if (response.data.responseCode == 200) {
        window.open(response.data.data, '_blank')
      } else {
        console.log('view report not available')
      }
    })
}

export const getBookmarks = (fileId) => (dispatch) => {
  console.log('Actions Validation Report Download')

  tasksAPI
    .post('/task/get-Coordinates-ForHeadings/', {
      file_id: fileId,
      page_number: 1,
      viewer_type: 'documentviewer',
      company_id: 337,
      task_id: fileId,
    })
    .then((response) => {
      console.log('REceived resoponse BKMARK', response.data)
      dispatch({
        type: VIEW_BOOKMARKS,
        payload: response?.data?.data,
      })
    })
}

export const updateJsonForBookMark = (fileId, pageJson) => (dispatch) => {
  console.log('Actions Validation Report Download')

  tasksAPI
    .post('/task/update-json-for-bookmark/', {
      file_id: fileId,
      page_number: 1,
      viewer_type: 'documentviewer',
      company_id: 337,
      task_id: fileId,
      page_json: pageJson,
    })
    .then((response) => {
      console.log('REceived resoponse update json for bookmark', response.data)
      //dispatch(getBookmarks(fileId))
      dispatch({
        type: BOOKMARK_UPDATE,
        payload: response?.data
      })
    })
}

export const getThumbnail = (pageNo, imgPath) => (dispatch) => {
  console.log('Actions Validation Report Download', imgPath)
  

  tasksAPI
    .post(`/task/file/viewForUser`, {
      destinationPath: imgPath,
      type: 's3',
      s3_version_id: '',
      versioned: 'false',
      company_id: 337,
    })
    .then((response) => {
      console.log('Thumb api call resp', response.data)

      dispatch({
        type: THUMBNAIL,
        payload: { pageNo: pageNo, url: response?.data?.data },
      })
    })
}

export const getFileCoOrdinates = (fileId, pageNo) => (dispatch) => {
  console.log('Actions Validation Report Download')

  tasksAPI
    .post(`task/get-Coordinates-ByViewerType/`, {
      file_id: fileId,
      page_number: pageNo,
      viewer_type: 'documentviewer',
    })
    .then((response) => {
      console.log('File Co-Ordinate ', response.data)

      dispatch({
        type: PAGE_DETAILS,
        payload: response?.data.data,
      })
    })
}

export const createImg = (id, pgno, element, rdOrder, UUID, type, xmin, xmax, ymin, ymax, pgH, pgW) => (dispatch) => {
  console.log('createImg Call', element, rdOrder, UUID, type, xmin, xmax, ymin, ymax, pgH, pgW)
  
  documentsAPI
    .post(`/document/update-coords-alt-text-data/`, {

      fileid:id,
      pageno: pgno,
      pagejsonCoord: {
        elementName:element,
        pageHeight:pgH,
        pageWidth:pgW,
        uniqueIdentifier:UUID,
        altTextLong:"",
        coordinates:{
            xmin : xmin,
            ymin : ymin,
            xmax : xmax,
            ymax : ymax
        },
        mathMl:"",
        decorative:false
     }
      
    })
    .then((response) => {
      console.log('createimg call ', response.data, element)
      sessionStorage.setItem("createImgElement", element);
      dispatch({
        type: CREATE_IMG,
        payload: response?.data.data,
      })
      
    })
}


export const delImg = (id, uuid, pgNo, type) => (dispatch) => {
  console.log('delImg Call', id, uuid, pgNo)

  documentsAPI
    .post(`/document/delete-alt-text/`, {
      task_id:id,
      unique_identifier:uuid,
      // page_no: pgNo
    })
    .then((response) => {
      //console.log('delimg call ', response.data)
      dispatch({
        type: DELETE_IMG,
        payload: response?.data.data,
      })
    })
}
export const delSingleImg = (id, uuid, pgNo, type) => (dispatch) => {
  //console.log('delImg Call', id, uuid, pgNo)

  documentsAPI
    .post(`/document/delete-alt-text-page/`, {
      task_id:id,
      unique_identifier:uuid,
      page_no: pgNo
    })
    .then((response) => {
      //console.log('delimg call ', response.data)
      dispatch({
        type: DELETE_IMG,
        payload: response?.data.data,
      })
    })
}

export const bulkDelImg = (id, pgNo) => (dispatch) => {
  console.log('Bulk-delImg Call', id, pgNo)

  documentsAPI
    .post(`/document/delete-alt-text/`, {
      task_id:id,
      //unique_identifier:uuid,
      page_no: pgNo
    })
    .then((response) => {
      //console.log('delimg call ', response.data)
      dispatch({
        type: BULK_DELETE_IMG,
        payload: response?.data.data,
      })
    })
}




export const resetAltText =() =>(dispatch) => {
  dispatch({
    type: RESET_ALT_IMG
  })
  
}

export const resetUpdateAlt =() =>(dispatch) => {
  dispatch({
    type: RESET_ALT_UPDATE
  })
  
}

export const resetAltTextVal =(val) =>(dispatch) => {
  dispatch({
    type: RESET_ALT_IMG_VAL,
    payload: val,
  })
  
}

export const altOneTimeLoadFlag =(val) =>(dispatch) => {
  dispatch({
    type: ALT_ONETIME_LOAD,
    payload: val,
  })
  
}


export const getFileMetadata = (fileId) => (dispatch) => {
  console.log('Actions Get metadata file')

  tasksAPI
    .post(`/task/get-file-metadata/`, {
      project_category_type_id: '10',
      type: 'task',
      file_id: fileId,
    })
    .then((response) => {
      console.log('File Co-Ordinate ', response.data)

      dispatch({
        type: METADATA_DETAILS,
        payload: response?.data.data,
      })
    })
}

export const getAltTextData = (fileId, type, is_deco, alt_text_missing) => (dispatch) => {
  console.log('Actions Get Alt Text ', type)

  documentsAPI
    .post(`/document/get-mydoc-file-altText/`, {
      task_id: fileId,
      alt_text_type: type,
      is_deco: is_deco,
      alt_text_missing: alt_text_missing,
    })
    .then((response) => {
      console.log('File Co-Ordinate ', response.data)

      dispatch({
        type:
          type === 'Fig'
            ? FIG_ALT_TEXT_DATA
            : type === 'For'
            ? FOR_ALT_TEXT_DATA
            : TAB_ALT_TEXT_DATA,
        payload: response?.data.data,
      })
    })
}

export const getViewerTags = (id) => (dispatch) => {
  console.log('getViewerTags')
  const userDetail = (encryptStorage.getItem('session-user'))
  tasksAPI
    .post(`/task/get-viewer-controls-by-viewer-type`, {
      viewer_type:"pdf",
      project_category_type_id:10,
      project_id:0,
      user_id:userDetail.user_id
    })
    .then((response) => {
      let tagList = response?.data.data;
      const permission = encryptStorage.getItem('editorPermisson_' + id)
      if(permission === 'Tagging_TASKS'){
        tagList = tagList.filter((tag)=>{ return tag.control_display_name !== 'Table' && tag.control_display_name !== 'For' && tag.control_display_name !== 'Fig' })
      }

      dispatch({
        type: VIEWER_TAGS,
        payload: tagList,
      })
    })
}

export const getAltTextImages = (identifier, imgPath) => (dispatch) => {
  console.log('Actions Validation Report Download', imgPath)

  tasksAPI
    .post(`/task/file/viewForUser`, {
      destinationPath: imgPath,
      type: 's3',
      s3_version_id: '',
      versioned: 'false',
      company_id: 337,
    })
    .then((response) => {
      console.log('Thumb api ALT Text resp', response.data)

      dispatch({
        type: THUMBNAIL_ALT_TEXT,
        payload: { identifier: identifier, url: response?.data?.data },
      })
    })
}

export const autoMathApi = (fileID, type, desc, fileName, s3Path, uuid) => (dispatch) => {
  console.log('autoMathApi', fileID, type, desc, fileName, s3Path, uuid)

  tasksAPI
    .post(`/document/update-coords-alt-text-data/`, {
      file_id: fileID,
      description: desc,
      file_name: fileName,
      s3_path: s3Path,
    })
    .then((response) => {
      console.log('autoMathApi updated', response.data)

      dispatch({
        type: AUTO_MATH_API,
        payload: response?.data?.data,
      })
    })
}

export const processImgAutoAlt=(id, des, imgName, s3path, type, pgHeigt, pgWidth,datas)=>{
  documentsAPI
  .post('/document/processImage', {
    file_id: id,
    description: des,
    file_name: imgName,
    s3_path: s3path
  })
  .then((response) =>
  {
    if (response.data.code == '200' && response.data.data) {
      let alt_text_long = response.data.data[imgName].data.description;
      console.log("alttext Auto generates:::", imgName, alt_text_long)
      dispatch({
        type: PROCESS_IMG_FLAG,
        payload: response?.data?.data,
      })
      //updateAltTextData(type, datas, des, alt_text_long, pgHeigt, pgWidth)
    }else{
      console.log("Error for auto alttext generate", imgName)
    }

  })
}

export const updateAltTextData =
  (type, tilex, decor, altTxt, pageHeight, pageWidth) => (dispatch) => {
    console.log('updateAltTextData', type, tilex, decor, altTxt)
    if (decor == 'true') altTxt = tilex.alt_text_long

    documentsAPI
      .post(`/document/update-coords-alt-text-data/`, {
        fileid: tilex.task_id,
        pageno: tilex.page_no,
        pagejsonCoord: {
          elementName: type,
          pageHeight: pageHeight,
          pageWidth: pageWidth,
          uniqueIdentifier: tilex.unique_identifier,
          altTextLong: altTxt,
          coordinates: {
            xmin: tilex.x_min,
            ymin: tilex.y_min,
            xmax: tilex.x_max,
            ymax: tilex.y_max,
          },
          mathMl: '<math>',
          decorative: decor,
        },
      })
      .then((response) => {
        console.log('altText updated', response.data)

        dispatch({
          type: UPDATE_ALT_TEXT,
          payload: response?.data?.statusMessage+"-"+tilex.unique_identifier,
        })
        //if(altTxt==undefined || altTxt==null || altTxt.toLowerCase()=="formula") altTxt="";
        if(altTxt==undefined || altTxt==null) altTxt="";
        dispatch({
          type: UPDATE_ALT_TEXT_STATE,
          payload:{type: type,uniqueIdentifier: tilex.unique_identifier, longDes:altTxt, imgName:tilex.image_name}
        })
      })
  }

export const getPageImage = (imgPath) => (dispatch) => {
  console.log('Actions Validation Report Download', imgPath)
  sessionStorage.removeItem("recentZone")
  tasksAPI
    .post(`/task/file/viewForUser`, {
      destinationPath: imgPath,
      type: 's3',
      s3_version_id: '',
      versioned: 'false',
      company_id: 337,
    })
    .then((response) => {
      console.log('Full Image resp', response.data)

      dispatch({
        type: PAGE_FULL_IMAGE,
        payload: response?.data?.data,
      })
    })
}

// export const setcanDrag =(canDrag) =>(dispatch) =>{
//   dispatch({
//     type: CAN_DRAG,
//     payload : canDrag
//   })
// }
export const setCanDrag = (value) => (dispatch) => {
  dispatch({
    type: SET_CAN_DRAG,
    payload: value,
  })
}

export const setCanDrawTag = (value) => (dispatch) => {
  dispatch({
    type: SET_CAN_DRAW_TAG,
    payload: value,
  })
}

export const setCurrentTagValue = (value) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_TAG_VALUE,
    payload: value,
  })
}

export const setNewCoordinates = (value) => (dispatch) => {
  dispatch({
    type: SET_NEW_COORDINATES,
    payload: value,
  })
}

export const setNewAltFig = (value) => (dispatch) => {
  dispatch({
    type: SET_NEW_ALTFIG,
    payload: value,
  })
}
export const setNewAltFor = (value) => (dispatch) => {
  dispatch({
    type: SET_NEW_ALTFOR,
    payload: value,
  })
}
export const setNewAltTab = (value) => (dispatch) => {
  dispatch({
    type: SET_NEW_ALTTAB,
    payload: value,
  })
}


export const setReviewComplete = (value) => (dispatch) => {
  
  dispatch({
    type: SET_REVIEW_COMPLETE,
    payload: value,
  })
}
export const setTableOprVisibility = (value) => (dispatch) => {
  console.log('Table operation visibility')
  dispatch({
    type: SET_TABLE_OPR_VISIBILITY,
    payload: value,
  })
}

export const setMergeOprVisibility = (value) => (dispatch) => {
  console.log('Merge operation visibility')
  dispatch({
    type: SET_MERGE_OPR_VISIBILITY,
    payload: value,
  })
}

export const setAltImgChgUpdate = (value) => (dispatch) => {
  console.log('ImageChangeUpdate')
  dispatch({
    type: ALTIMG_CHANGE,
    payload: value,
  })
}

export const setListOprVisibility = (value) => (dispatch) => {
    dispatch({
      type: SET_LIST_OPR_VISIBILITY,
      payload: value,
    })
  }

export const setZoneOprVisibility = (value) => (dispatch) => {
  console.log("setZoneOprVisibility", value)
    dispatch({
      type: SET_ZONE_OPR_VISIBILITY,
      payload: value,
    })
  }

  export const setTOCOprVisibility = (value) => (dispatch) => {
    console.log("setTOCOprVisibility", value)
    dispatch({
      type: SET_TOC_OPR_VISIBILITY,
      payload: value,
    })
  }
  

export const setCanDrawRow = (value) => (dispatch) => {
  console.log('Row drawing enabling')
  dispatch({
    type: SET_DRAW_ROW,
    payload: value,
  })
}
export const setCanDrawColumn = (value) => (dispatch) => {
  console.log('Column drawing enabling')
  dispatch({
    type: SET_DRAW_COLUMN,
    payload: value,
  })
}

export const setEnableGenerateTableButton = (value) => (dispatch) => {
  console.log('Column drawing enabling')
  dispatch({
    type: SET_ENABLE_GENERATE_TABLE,
    payload: value,
  })
}

export const setEnableMergeCellsButton = (value) => (dispatch) => {
  console.log('Column drawing enabling')
  dispatch({
    type: SET_ENABLE_MERGE_CELLS,
    payload: value,
  })
}



export const completeReview = (data) => (dispatch) => {
  console.log('Complete review', data)

  fixFileApi
    .post(`/fix/Accessibilitytagging`, data)
    .then((response) => {
      console.log('Review Response ', response.data)

      
      dispatch({
        type: COMPLETE_REVIEW,
        payload: response?.data
      })
    })
}
export const setCanDeleteRow = (value) => (dispatch) => {
  console.log('Row drawing deletion')
  dispatch({
    type: SET_DELETE_ROW,
    payload: value,
  })
}
export const setCanDeleteColumn = (value) => (dispatch) => {
  console.log('Column drawing deletion')
  dispatch({
    type: SET_DELETE_COLUMN,
    payload: value,
  })
}
export const setIsTableTagGenerated = (value) => (dispatch) => {
  console.log('table tag generation:')
  dispatch({
    type: SET_TABLE_TAG_GENERATED,
    payload: value,
  })
}
export const setIsMergeZone = (value) => (dispatch) => {
  console.log('table tag generation:')
  dispatch({
    type: SET_ZONE_MERGED,
    payload: value,
  })
}

export const setTocCreate = (value) => (dispatch) => {
  console.log('setTocCreate generation:')
  dispatch({
    type: SET_TOC_CREATE,
    payload: value,
  })
}

export const setIsDeleteZone = (value) => (dispatch) => {
  console.log('table tag generation:')
  dispatch({
    type: SET_ZONE_DELETE,
    payload: value,
  })
}
export const setSelectedZone = (value) => (dispatch) => {
  console.log('select zone:',value)
  dispatch({
    type: SELECTED_ZONE,
    payload: value,
  })
}




export const setIsMergeCells = (value) => (dispatch) => {
  console.log('table tag generation:')
  dispatch({
    type: SET_MERGE_CELLS,
    payload: value,
  })
}

export const setselectedTagId = (val) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_TAG_ID,
    payload: val,
  })
}

export const addIncompleteTable = (value)=>(dispatch) =>{
  dispatch({
    type: ADD_IN_COMPLETE_TABLE,
    payload: value,
  })
}

export const removeIncompleteTable = (value)=>(dispatch) =>{
  dispatch({
    type: REMOVE_IN_COMPLETE_TABLE,
    payload: value,
  })
}

export const setImageLoadingStatus = (value)=>(dispatch) =>{
  dispatch({
    type: IMAGE_LOADING_STATUS,
    payload: value,
  })
}

export const focusThumbnailTray = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: FOCUS_THUMBNAILS,
    payload: val
  })
}

export const resetObjectProperty = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: RESET_OBJ_PROPERTY,
    payload: val
  })
}

export const setSelectedZoneValue = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SELECTED_ZONE_VALUE,
    payload: val
  })
}

export const saveDoc = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SAVE_DOC_VALUE,
    payload: val
  })
}
export const showMetadataAlert = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SHOW_METADATA_ALERT,
    payload: val
  })
}
export const setApplyFlag = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_APPLY_FLAG,
    payload: val
  })
}

export const setThumbnailFocus = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_THUMBNAIL_FOCUS,
    payload: val
  })
}


export const setBookmarkTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_BOOKMARK_TI,
    payload: val
  })
}
export const setBkTrayTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_BK_TRAY_TI,
    payload: val
  })
}
export const setDocTagTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_DOC_TAG_TI,
    payload: val
  })
}



export const setDtTrayTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_DOC_TAG_TRAY_TI,
    payload: val
  })
}
export const setReportTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_REPORT_TI,
    payload: val
  })
}

export const setVrTrayTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_VR_TRAY_TI,
    payload: val
  })
}

export const setTopbarTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_TOPBAR_TI,
    payload: val
  })
}
export const setDocDetailsTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  //debugger;
  dispatch({
    type: SET_DOC_DETAILS_TI,
    payload: val
  })
}
export const setDocDetailsTrayTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_DOC_DETAILS_TRAY_TI,
    payload: val
  })
}

export const setTagTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_TAG_TI,
    payload: val
  })
}

export const setTagsTrayTabIndex = (val) => (dispatch) => {
  //console.log('toggleKeyBoardShortcut action')
  dispatch({
    type: SET_TAG_TRAY_TI,
    payload: val
  })
}

















